export const config = {
    configName: "config8",
    title: "Cashier",
    logo: null,
    assetsLink: "https://assets-core.{{domain}}/images/Cashier_cubes_preloader.gif",
        api: "https://api-{{domain}}/api/", // reqular cashier domain to hermes trough Cashier Gateway
    apiTheme: "https://compute-core.{{domain}}/hermes-assets/",
    origin: "https://helios-core.cashier-dev.com",
    withdrawRequests: true,
    activityScript: false,
    defaultDomain: "cashier-dev.com",
    defaultPciDomain: "cashier-dev.com",
    apiServer: "https://atlas-core.cashier-dev.com/",
    pciLink: `https://pci-api-core.{{domain}}/PraxisGate.js?t=${new Date().getTime()}`,
    socketUrl: 'wss://prometheus-core.{{domain}}/',
    publicKeyForEncrypt: "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAsJqf6qf3buGQrXBQpv+82Sn/Y9igi4br/+L4UydCCJHcZm0eECzI91Kw0HZBJvCFlsnCNQFdylYoI/ogtpYk3TyPJZw11zI/n+ouurqEBs7l346LLSCcrm4X1DjMM1TLLWkV8HwRKmHZclQaE1ZDs2F6gs775imCItHh2PR1yGIoIJ8+IGgIFwjQX4iMxKiD74QA+XuWYOPtVcOVIaUgupz9cKj66ia158iDTtib9rUVw0wsgw26js15I4poWyhejRisf0mnoOY41t5zMfUO56lKKcOjoHXaP1p2AX5AF4WlwM1IisHPf8D/BAhywp7c7XfdiyzBxN9nnaBqSSOI0wIDAQAB",
    signatureSecretKey: "SvX6meGq9o",
    graphqlDomain: 'https://api-terminal-core.{{domain}}/graphql', //for @pano-project - panoramic-2-0-theme
    editorGraphQlDomain: 'https://api-terminal-core.{{domain}}/graphql',
    graphqlTestAuthToken: '4fHV3aGaPOwCB9vHoRaI%2BoostCpQehHYac8XuL4XD4Gj463EB2F7Gk2oRULUJhXc', //for @pano-project - panoramic-2-0-theme
};
